/**
 * Webhook Types (Frontend)
 * Defines interfaces for webhook management in the frontend
 */

export interface Webhook {
  id: string;
  targetUrl: string;
  operations: string[];
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateWebhookRequest {
  targetUrl: string;
  operations: string[];
}

export interface UpdateWebhookRequest {
  targetUrl?: string;
  operations?: string[];
}

export interface WebhookTestResult {
  success: boolean;
  statusCode?: number;
  error?: string;
  responseTime?: number;
}

export const WEBHOOK_OPERATIONS = [
  { value: 'create', label: 'Create' },
  { value: 'update', label: 'Update' },
  { value: 'delete', label: 'Delete' },
] as const;

export type WebhookOperation = 'create' | 'update' | 'delete';
